import toPairs from 'lodash/toPairs';
import { useEffect, useState } from 'react';

import { getAccessTokenFromCookie } from '../../../../../../services/auth';
import { getToJson } from '../../../../../utils/io';
import { DIP_CONFIG_URL } from '../../../../../utils/midas-constants';
import { DataQueryFeed, WorkflowQueryOptions, WorkflowQueryOptionsValues } from '../../../../types';

interface DipConfig {
  feedsAndGroups: Record<string, string[]>;
  values: { name: string; definition: string; supportsLevel: boolean }[];
}

export default function useCacheOrFetch(options: WorkflowQueryOptions) {
  const [data, setData] = useState(options);

  useEffect(() => {
    if (options.feedsAndGroupsTree.length && options.values) {
      setData((prevData) => ({ ...prevData, loading: false }));
      return;
    }

    void (async () => {
      try {
        const { feedsAndGroups, values: rawValues } = await getToJson<DipConfig>(DIP_CONFIG_URL, getAccessTokenFromCookie());

        const feedsAndGroupsTree: DataQueryFeed[] = toPairs(feedsAndGroups).map(([feedName, feeds]) => ({
          key: feedName,
          value: feedName,
          title: feedName,
          selectable: true,
          children: feeds.map((feed) => ({
            key: `${feedName}/${feed}`,
            value: `${feedName}/${feed}`,
            title: feed,
            selectable: true,
          })),
        }));

        const values = rawValues.reduce(
          (result: WorkflowQueryOptionsValues, { name, supportsLevel }) => {
            result.options.push({ value: name });

            if (supportsLevel) {
              result.supportLevelValues.push(name);
            }

            return result;
          },
          {
            options: [],
            supportLevelValues: [],
          }
        );

        // TODO: cache or inform Wizard here?
        setData({ feedsAndGroupsTree, values, loading: false });
      } catch (error) {
        console.error('[useCacheOrFetch] failed to load sources from server..', error);
        setData((prevData) => ({ ...prevData, loading: false }));
      }
    })();
  }, [options]);

  return data;
}
